import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=245e5d1d&scoped=true"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"
import style0 from "./customSelect.vue?vue&type=style&index=0&id=245e5d1d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e5d1d",
  null
  
)

export default component.exports